"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UserAddSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10,9 L10,7.73243561 C10.5978014,7.38662619 11,6.74028236 11,6 C11,4.8954305 10.1045695,4 9,4 C7.8954305,4 7,4.8954305 7,6 C7,6.74028236 7.40219863,7.38662619 8,7.73243561 L8,9.12601749 C6.27477279,9.57006028 5,11.1361606 5,13 L5,14 L9,14 L9,15 L5,15 C4.44771525,15 4,14.5522847 4,14 L4,13 C4,10.8948158 5.30102603,9.09350251 7.14289226,8.35624595 C6.44680015,7.80685854 6,6.95560715 6,6 C6,4.34314575 7.34314575,3 9,3 C10.6568542,3 12,4.34314575 12,6 C12,6.89068124 11.6118504,7.69070528 10.9954753,8.24014804 C10.9984918,8.74671601 11,9 11,9 L10,9 Z M12,12 L12,10 L13,10 L13,12 L15,12 L15,13 L13,13 L13,15 L12,15 L12,13 L10,13 L10,12 L12,12 Z" })));
};
UserAddSmall.displayName = 'UserAddSmall';
exports.default = UserAddSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UserAddSmall.js.map